import axios from "./axios";
import { memoize } from "lodash";

function memoizeResolver(...args) {
  return JSON.stringify(args);
}

async function missingKeyHandler(lng, ns, key, fallbackValue) {
  // console.warn(`Missing key [${lng}] '${ns}:${key}'`);
  return axios.get("/api/development/missingKey", {
    params: { lng, ns, key, fallbackValue },
  });
}

export default memoize(missingKeyHandler, memoizeResolver);
